<template>
  <div class="text-center mt-10 pt-10">
    <p class="display-1">🙏</p>
    <p class="display-3">404</p>
    <p class="subtitle-1">Halaman yang anda cari tidak ditemukan</p>
    <p class="subtitle-1">
      <a href="/">Kembali</a>
      <strong class="mx-3">|</strong>
      <a href="/#/login">Log in</a>
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>